// Importar override de console ANTES de cualquier otro código para deshabilitar logs
import './utils/consoleOverride.js';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { lazy, Suspense } from 'react';
import { AnimatePresence } from 'framer-motion';
import { BrowserRouter } from 'react-router-dom';
import "boxicons/css/boxicons.min.css";
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import Loader from './Components/Loader/Loader';
import { InvoiceProvider } from "./contexts/InvoiceContext";
import { UserProvider } from './contexts/UserContext';
import { ProfilePictureProvider } from './contexts/ProfilePictureContext';
import { AuthProvider } from './contexts/AuthContext';
import { BillingLoadingProvider } from './contexts/BillingLoadingContext';
import { Toaster } from 'react-hot-toast';
import { initCacheCleanupService } from './utils/cacheCleanup';

// Importamos sin dependencia React
import './utils/globalEventManager';

const App = lazy(() => import('./App'));

// Inicializar el servicio de limpieza de caché
initCacheCleanupService();

// Componente de carga global simplificado para usar solo el logo giratorio
const RootLoader = () => (
    <div className="fixed inset-0 flex items-center justify-center bg-[#1A1A1D]">
        <Loader size="large" />
    </div>
);

const Root = () => (
    <StrictMode>
        <BrowserRouter>
            <AnimatePresence mode="wait">
                <Suspense fallback={<RootLoader />}>
                    <AuthProvider>
                    <UserProvider>
                        <ProfilePictureProvider>
                            <InvoiceProvider>
                                    <BillingLoadingProvider>
                                <App />
                                <Toaster position="top-right" />
                                    </BillingLoadingProvider>
                            </InvoiceProvider>
                        </ProfilePictureProvider>
                    </UserProvider>
                    </AuthProvider>
                </Suspense>
            </AnimatePresence>
        </BrowserRouter>
    </StrictMode>
);

const container = document.getElementById('root');
if (container) {
    // Usar una referencia global para evitar doble inicialización en HMR o scripts duplicados
    if (!window._reactRoot) {
        window._reactRoot = createRoot(container);
    }
    window._reactRoot.render(<Root />);
}
